// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QChgX","toggle":"styles_toggle__GVcT8","preview":"styles_preview__2tPjJ"};